import type { Schemas } from "~/types/generated";

export enum NewsModeEnum {
  MATCHED = "matched",
  CATEGORY = "category",
  EMPTY = "empty",
}

export enum NewsRelevanceEnum {
  HIGH = "High",
  MEDIUM = "Medium",
  LOW = "Low",
}

export type INewsArticle = Schemas["NewsArticleDto"];

export type INewsFeed = Schemas["NewsFeedResponseDto"];
